@if (!habilitaAsegurado) {
  <div class="row m-0 p-1">
    <div class="col-md-12  d-flex justify-content-end">
      <button color="primary" mat-raised-button type="button" (click)="abrirSeccionTercero()" [disabled]="false">
        <i class="fas fa-plus"></i>&nbsp;Nuevo
      </button>
    </div>
    <div class="col-md-12 my-4 overflow-auto">
      <table mat-table multiTemplateDataRows [dataSource]="datosTercero.data | slice:(paginatorInfo?.pageStart ? paginatorInfo?.pageStart - 1 : 0):paginatorInfo?.pageEnd"
        class="table d-xl-table d-md-table d-sm-table d-table table-responsive my-2">
        <ng-container matColumnDef="TipoTercero">
          <th mat-header-cell class="px-2" *matHeaderCellDef>Tipo tercero</th>
          <td mat-cell *matCellDef="let element" class="mx-1">{{element?.desc_tipo_tercero}}</td>
        </ng-container>
        <ng-container matColumnDef="Nombre">
          <th mat-header-cell class="px-2" *matHeaderCellDef>Nombre</th>
          <td mat-cell *matCellDef="let element" class="mx-1">{{element?.nombre}}</td>
        </ng-container>
        <ng-container matColumnDef="Estatus">
          <th mat-header-cell class="px-2" *matHeaderCellDef>Estatus</th>
          <td mat-cell *matCellDef="let element" class="mx-1">{{ element?.desc_estatus}}</td>
        </ng-container>
        <ng-container matColumnDef="Acciones">
          <th mat-header-cell class="px-2" *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element" class="mx-1">
            <div class="row justify-content-center">
              <div class="col-md-auto">
                <button color="primary" mat-raised-button type="button"
                  (click)="abrirSeccionTercero(element)" [disabled]="false">
                  <i class="fas fa-edit"></i>
                </button>
              </div>
              <div class="col-md-auto">
                <button color="warn" mat-raised-button type="button" (click)="validaEliminacion(element)"
                  [disabled]="false">
                  <i class="fas fa-trash"></i>
                </button>
              </div>
            </div>
          </td>
        </ng-container>
        <!-- Sin resultados -->
        <ng-container matColumnDef="noData">
          <td mat-footer-cell *matFooterCellDef colspan="4">
            <small>No se encontró ningún resultado</small>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayColumns;"> </tr>
        <tr mat-footer-row *matFooterRowDef="['noData']"
          [ngClass]="(datosTercero?.data?.length === 0) ? '':'ocultarPaginator'">
        </tr>
      </table>
      <app-pagina-datos-tabla (eventPaginator)="paginatorInfo = $event" (click)="$event.stopPropagation()"
        [style.visibility]="datosTercero?.data?.length >= 6 ? 'visible' : 'hidden'"
        [showFisrtLastButton]="true"
        [registerPerPage]="5"
        [totalLength]="datosTercero?.data?.length"
      ></app-pagina-datos-tabla>
    </div>
  </div>
}

@if (habilitaAsegurado) {
  <form [formGroup]="formAsegurado" class="row m-0 p-4">
    <div class="col-md-4 d-flex align-items-center gap-1">
      <mat-form-field class="inputFormularioSmall">
        <mat-label>Tipo tercero:</mat-label>
        <input matInput formControlName="tipoTercero">
        @if (formAsegurado.get('tipoTercero').hasError('required')) {
          <mat-error>Campo obligatorio</mat-error>
        }
      </mat-form-field>
      @if (!this.lesionadoSeleccionado?.hospital_lesionado > 0) {
        <button style="margin-top:-20px" mat-mini-fab color="accent" (click)="abrirModalTiposTerceros()">
          <mat-icon>search</mat-icon>
        </button>
      }
    </div>
    <div class="col-md-4"></div>
    <div class="col-md-4"></div>
    <div class="col-md-4">
      <mat-form-field class="inputFormularioSmall">
        <mat-label>Estatus:</mat-label>
        <mat-select formControlName="estatus"  placeholder="Seleccionar">
          @for (est of catEstatus; track est) {
            <mat-option [value]="est.valor_dato">{{ est.descripl_dato }}</mat-option>
          }
        </mat-select>
        @if (formAsegurado.get('estatus').hasError('required')) {
          <mat-error>Campo obligatorio</mat-error>
        }
      </mat-form-field>
    </div>
    <div class="col-md-4"></div>
    <div class="col-md-4"></div>
    <div class="col-md-4">
      <mat-form-field class="inputFormularioSmall">
        <mat-label>Nombre:</mat-label>
        <input matInput placeholder="Nombre" formControlName="nombre" [UpperCase]="true">
        <mat-error>Campo obligatorio</mat-error>
      </mat-form-field>
    </div>
    <div class="col-md-4">
      <mat-form-field class="inputFormularioSmall">
        <mat-label>A. Paterno:</mat-label>
        <input matInput placeholder="A. Paterno" formControlName="apellidoPaterno"  [UpperCase]="true">
        <mat-error>Campo obligatorio</mat-error>
      </mat-form-field>
    </div>
    <div class="col-md-4">
      <mat-form-field class="inputFormularioSmall">
        <mat-label>A. Materno:</mat-label>
        <input matInput placeholder="A. Materno" formControlName="apellidoMaterno"  [UpperCase]="true">
        <mat-error>Campo obligatorio</mat-error>
      </mat-form-field>
    </div>
    <div class="col-md-4">
      <mat-form-field class="inputFormularioSmall">
        <mat-label>Edad:</mat-label>
        <input matInput formControlName="edad" type="text" [OnlyNumber]="true" maxlength="3">
        <mat-error>Campo obligatorio</mat-error>
      </mat-form-field>
    </div>
    <div class="col-md-4"></div>
    <div class="col-md-4"></div>
    @if (this.formAsegurado.getRawValue()?.estatus != 3 && (lesionadoSeleccionado == null || lesionadoSeleccionado?.tipo_prestador != 21)) {
      <div class="col-md-4">
        <mat-form-field class="inputFormularioSmall">
          <mat-label>Importe:</mat-label>
          <input matInput formControlName="importe" type="text" formatoMoneda tipoFormato="moneda" maxlength="15">
          @if (formAsegurado.get('importe').hasError('required')) {
            <mat-error>
              El importe es obligatorio
            </mat-error>
          }
          @if (formAsegurado.get('importe').hasError('importeInvalido')) {
            <mat-error>
              El importe debe ser mayor a cero
            </mat-error>
          }
        </mat-form-field>
      </div>
    }
  </form>
}

@if (habilitaAsegurado) {
  <div class="row m-0 p-1 justify-content-end">
    <div class="col-md-auto d-flex justify-content-end">
      <button color="accent" mat-raised-button type="button" (click)="regresaConsulta()" [disabled]="false">
        Regresar
      </button>
    </div>
    <div class="col-md-auto d-flex justify-content-end">
      <button color="primary" mat-raised-button type="button" (click)="guardarTercero(this.lesionadoSeleccionado)" [disabled]="false">
        Guardar
      </button>
    </div>
  </div>
}